// DIALOG MANAGEMENT

export const SHOW_INFO_DIALOG = "SHOW_INFO_DIALOG";
export const HIDE_INFO_DIALOG = "HIDE_INFO_DIALOG";
export const CLEAR_INFO_CONTENT = "CLEAR_INFO_CONTENT";

export const SHOW_CONFIRMATION_DIALOG = "SHOW_CONFIRMATION_DIALOG";
export const HIDE_CONFIRMATION_DIALOG = "HIDE_CONFIRMATION_DIALOG";
export const CLEAR_CONFIRMATION_CONTENT = "CLEAR_CONFIRMATION_CONTENT";

export const UPDATE_NO_CV_DIALOG_STATUS = "UPDATE_NO_CV_DIALOG_STATUS";

//alert banner
export const UPDATE_ALERT_BANNER = "UPDATE_ALERT_BANNER";

//For You Resume Dialog
export const UPDATE_FOR_YOU_RESUME_DIALOG_STATUS =
  "UPDATE_FOR_YOU_RESUME_DIALOG_STATUS";
export const UPDATE_REFRESH_DIALOG_STATUS = "UPDATE_REFRESH_DIALOG_STATUS";

//post apply dialog
export const UPDATE_POST_APPLY_DIALOG = "UPDATE_POST_APPLY_DIALOG";
export const UPDATE_BULK_APPLY_STATE = "UPDATE_BULK_APPLY_STATE";

export const UPDATE_SHOW_SIMILAR_JOBS_STATUS =
  "UPDATE_SHOW_SIMILAR_JOBS_STATUS";

export const UPDATE_JOB_ALERT_DIALOG = "UPDATE_JOB_ALERT_DIALOG";

export const UPDATE_JOB_ALERT_NOTIFICATIONS_DIALOG =
  "UPDATE_JOB_ALERT_NOTIFICATIONS_DIALOG";

export const UPDATE_JOB_ALERT_DELETE_DIALOG = "UPDATE_JOB_ALERT_DELETE_DIALOG";

export const UPDATE_JOB_ALERT_DISABLE_ALL_DIALOG =
  "UPDATE_JOB_ALERT_DISABLE_ALL_DIALOG";

export const UPDATE_JOB_ALERT_DOWNLOAD_APP_DIALOG =
  "UPDATE_JOB_ALERT_DOWNLOAD_APP_DIALOG";

export const UPDATE_JOB_ALERT_VISITOR_EMAIL_DIALOG =
  "UPDATE_JOB_ALERT_VISITOR_EMAIL_DIALOG";

export const UPDATE_JOB_ALERT_VISITOR_UNSUBSCRIBE_DIALOG =
  "UPDATE_JOB_ALERT_VISITOR_UNSUBSCRIBE_DIALOG";

export const SHOW_INFO_DIALOG_ACTIVELY_AVAILABLE =
  "SHOW_INFO_DIALOG_ACTIVELY_AVAILABLE";

export const UPDATE_JOB_ALERT_CREATE_DIALOG = "UPDATE_JOB_ALERT_CREATE_DIALOG";

export const UPDATE_JOB_ALERT_CREATE_DIALOG_KEYWORD =
  "UPDATE_JOB_ALERT_CREATE_DIALOG_KEYWORD";

export const UPDATE_JOB_DETAILS_VISITOR_JOB_ALERT_DIALOG =
  "UPDATE_JOB_DETAILS_VISITOR_JOB_ALERT_DIALOG";

export const UPDATE_VISITOR_JOB_ALERT_DIALOG_DETAILS =
  "UPDATE_VISITOR_JOB_ALERT_DIALOG_DETAILS";

export const UPDATE_VISITOR_JOB_ALERT_DIALOG_ORIGIN =
  "UPDATE_VISITOR_JOB_ALERT_DIALOG_ORIGIN";

export const UPDATE_SECONDARY_VISITOR_DIALOG =
  "UPDATE_SECONDARY_VISITOR_DIALOG";

export const UPDATE_RESUME_CONFIRMATION_DIALOG =
  "UPDATE_RESUME_CONFIRMATION_DIALOG";
export const UPDATE_PROFILE_PREVIEW_DIALOG = "UPDATE_PROFILE_PREVIEW_DIALOG";
export const UPDATE_SIGN_UP_PROFILE_DIALOG = "UPDATE_SIGN_UP_PROFILE_DIALOG";
export const UPDATE_RESUME_FEEDBACK_DIALOG = "UPDATE_RESUME_FEEDBACK_DIALOG";

export const UPDATE_ASHLEY_EDIT_NO_RESUME_DIALOG =
  "UPDATE_ASHLEY_EDIT_NO_RESUME_DIALOG";
export const UPDATE_ASHLEY_EDIT_DIALOG = "UPDATE_ASHLEY_EDIT_DIALOG";
export const UPDATE_ASHLEY_EDIT_CONFIRMATION_DIALOG =
  "UPDATE_ASHLEY_EDIT_CONFIRMATION_DIALOG";

export const UPDATE_CONTACT_US_EMPLOYER_DIALOG =
  "UPDATE_CONTACT_US_EMPLOYER_DIALOG";

export const UPDATE_VIEW_PRODUCT_EMPLOYER_DIALOG =
  "UPDATE_VIEW_PRODUCT_EMPLOYER_DIALOG";

export const UPDATE_SG_JOB_REMINDER_DIALOG = "UPDATE_SG_JOB_REMINDER_DIALOG";

export const UPDATE_HOMEPAGE_UPLOADED_RESUME_DIALOG =
  "UPDATE_HOMEPAGE_UPLOADED_RESUME_DIALOG";
export const UPDATE_HOMEPAGE_REPLACE_RESUME_DIALOG =
  "UPDATE_HOMEPAGE_REPLACE_RESUME_DIALOG";
export const UPDATE_HOMEPAGE_VIEW_RESUME_DIALOG =
  "UPDATE_HOMEPAGE_VIEW_RESUME_DIALOG";

export const UPDATE_EXIT_DIALOG = "UPDATE_EXIT_DIALOG";

export const UPDATE_CURRENT_SALARY_DIALOG = "UPDATE_CURRENT_SALARY_DIALOG"; 

export const UPDATE_LANGUAGE_DETAILS_DIALOG = "UPDATE_LANGUAGE_DETAILS_DIALOG";